import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import HelpIcon from '@mui/icons-material/Help';
import Fab from '@mui/material/Fab';

import LinearProgress from '@mui/material/LinearProgress';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { Resizable } from 're-resizable';

import Bs4Box from './Bs4Components/Bs4Box';
import Bs4Modal from './Bs4Components/Bs4Modal'
import { EventEmit } from './Bs4Components/Bs4Utils'

import Bs4MainDispatch from './Bs4MainDispatch';
import Bs4MainWindow from './Bs4MainWindow';
import Bs4ShowTooltip from './Bs4ShowTooltip';

import bs4OptionBinding from './Bs4OptionBinding';
import Bs4HorizontalMenu from './Bs4Menu/Bs4HorizontalMenu';
import Bs4VerticalMenu from './Bs4Menu/Bs4VerticalMenu';

import { UxTemplateEditor, getUxTemplate, getBoxSx, useStateUxTemplate, SmallScreenContext } from './Bs4Theme/Bs4UxTemplates';
import { HideOnScroll } from './Bs4Components/HideOnScroll';
import Bs4I18N from './Bs4I18N';
import Bs4Form from './Bs4Form/Bs4Form';
import {isNullOrNaN, shallowEqual} from './Bs4Components/Bs4Utils';

const TYPE_BS4KARTOTEKA = 'type_Bs4Kartoteka';

export default class Bs4Kartoteka {  
  static DOCKING_REGION_CENTER = 'center';
  static DOCKING_REGION_RIGHT = 'right';
  static DOCKING_REGION_BOTTOM = 'bottom';
  static DOCKING_REGION_WINDOW = 'window';
  static DOCKING_REGION_NEW_TAB = 'new_tab';

  static CHANGE_VISIBILITY = 'change_visibility';
  static VISIBILITY_VISIBLE = 'visible';
  static VISIBILITY_HIDDEN = 'hidden';
  static BS4KARTOTEKA_FAB_POSITION = 'bs4kartoteka_fab_position';
  
  static smallScreen = null;

  static bs4KartotekaMap = new Map();

  static getDockingRegion(message) {
    // 1593 – Dynamiczne w webview otwieranie kartotek zamiast w tabie - w bieżącym oknie na cały ekran
    if ((Bs4MainDispatch.getMobile() || Bs4Kartoteka.smallScreen) && message._Komunikat.bs4CardType === '14') message._Komunikat.bs4CardType = '1';

    let dockingRegion = Bs4Kartoteka.DOCKING_REGION_CENTER;
		if (['12', '15', '16'].includes(message?._Komunikat?.bs4CardType)) dockingRegion = Bs4Kartoteka.DOCKING_REGION_WINDOW;
    if (message._Komunikat.bs4CardType === '14') dockingRegion = Bs4Kartoteka.DOCKING_REGION_NEW_TAB;
    if (message._Komunikat.bs4CardType === '17') dockingRegion = Bs4Kartoteka.DOCKING_REGION_RIGHT;

		if (![Bs4Kartoteka.DOCKING_REGION_WINDOW, Bs4Kartoteka.DOCKING_REGION_CENTER, Bs4Kartoteka.DOCKING_REGION_NEW_TAB,
      Bs4Kartoteka.DOCKING_REGION_RIGHT, Bs4Kartoteka.DOCKING_REGION_BOTTOM].includes(dockingRegion)) {
			dockingRegion = Bs4Kartoteka.DOCKING_REGION_CENTER;
		}

    if (dockingRegion === Bs4Kartoteka.DOCKING_REGION_RIGHT) {
      const bs4Kartoteka = Bs4Kartoteka.get(message._IdBs4Source);
      if (bs4Kartoteka?.dockingRegion === Bs4Kartoteka.DOCKING_REGION_RIGHT) {
        //2023-11-02 ML
        //Jeżeli prawa kartoteka chce otworzyć kolejną po prawej, otwieramy centralnie.
        dockingRegion = Bs4Kartoteka.DOCKING_REGION_CENTER;
      }
    }
      
    return dockingRegion;
  }

  static clear() {
    Bs4Kartoteka.bs4KartotekaMap.clear();
  }

  static add(bs4Kartoteka) {
    if (Bs4Kartoteka.bs4KartotekaMap.has(bs4Kartoteka.bs4KartotekaId)) {
      console.log('...Ponowne uruchomienie istniejącej kartoteki  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
      console.log('...Ponowne uruchomienie istniejącej kartoteki  już jest', Bs4Kartoteka.bs4KartotekaMap.get(bs4Kartoteka.bs4KartotekaId)?.message);
      console.log('...Ponowne uruchomienie istniejącej kartoteki  przychodzi:', bs4Kartoteka?.message);      
    }

    Bs4Kartoteka.bs4KartotekaMap.set(bs4Kartoteka.bs4KartotekaId, bs4Kartoteka);
    if (Bs4Kartoteka.bs4KartotekaMap.size === 1) bs4Kartoteka.first = true;
  }

  static get(bs4KartotekaId) {
    return Bs4Kartoteka.bs4KartotekaMap.get(bs4KartotekaId);
  }

  static getFirst() {
    return Array.from(Bs4Kartoteka.bs4KartotekaMap.values()).shift();
  }

  static getLast() {
    return Array.from(Bs4Kartoteka.bs4KartotekaMap.values()).pop();
  }

  static getNext(bs4KartotekaId) {
    let next = false;
    for (let [id, bs4Kartoteka] of Array.from(Bs4Kartoteka.bs4KartotekaMap)) {
      if (next) return bs4Kartoteka;
      if (bs4KartotekaId === bs4Kartoteka.bs4KartotekaId) next = true;
    }
    return null;
  }

  static getParent(bs4Kartoteka) {
    return Bs4Kartoteka.get(bs4Kartoteka.bs4SourceKartotekaId);
  }  

  static getRightChild(bs4KartotekaId) {    
    return Array.from(Bs4Kartoteka.bs4KartotekaMap.values()).filter(bs4KartotekaChild => 
      bs4KartotekaChild.bs4SourceKartotekaId === bs4KartotekaId && bs4KartotekaChild.dockingRegion === Bs4Kartoteka.DOCKING_REGION_RIGHT
    ).pop();
  }

  static remove(bs4KartotekaId) {
    return new Promise((resolve, reject) => {
      const bs4Kartoteka = Bs4Kartoteka.get(bs4KartotekaId);
      if (!bs4Kartoteka) {
        resolve('not exists', bs4KartotekaId);
        return;
      }
    
      // if (bs4Kartoteka.isFirst()) {
      //   console.log('=== bs4KartotekaId is first ===', bs4Kartoteka);
      //   reject('bs4KartotekaId is first');
      //   return;
      // }
      
      Bs4Kartoteka.remove(Bs4Kartoteka.getNext(bs4KartotekaId)?.bs4KartotekaId)
      .then(msg => {
        bs4Kartoteka.canClose()
        .then(msg => {          
          Bs4Kartoteka.bs4KartotekaMap.delete(bs4KartotekaId);
          bs4Kartoteka.lastCommandParserAfterRow?.deSelect();
          resolve(msg);
        })
        .catch(msg => reject(msg))
      })
      .catch(msg => reject(msg));
    });
  }

  static topBs4Kartoteka = null;

  static getShowStack = (smallScreen) => {
    const dokingRegionShowStack = [Bs4Kartoteka.DOCKING_REGION_CENTER, Bs4Kartoteka.DOCKING_REGION_WINDOW];
    if (smallScreen) dokingRegionShowStack.push(Bs4Kartoteka.DOCKING_REGION_RIGHT);
    const bs4KartotekaShowStack = Array.from(Bs4Kartoteka.bs4KartotekaMap.values()).filter(bs4Kartoteka => dokingRegionShowStack.includes(bs4Kartoteka.dockingRegion));
    
    let isTop = true;
    let visibility = true;
    const showStack = bs4KartotekaShowStack.reverse().map(bs4Kartoteka => {
      /// test if (!bs4Kartoteka.isFirst()) bs4Kartoteka.dockingRegion = Bs4Kartoteka.DOCKING_REGION_WINDOW;
      /// test bs4Kartoteka.dockingRegion = Bs4Kartoteka.DOCKING_REGION_CENTER;
      bs4Kartoteka.setVisibility(visibility, smallScreen);
      bs4Kartoteka.isTop = isTop;
      isTop = false;
      if (visibility && bs4Kartoteka.dockingRegion === Bs4Kartoteka.DOCKING_REGION_CENTER || smallScreen) {
        visibility = false;
        document.title = bs4Kartoteka.getTitle().title1;
      }

      return bs4Kartoteka;
    })   

    const showStackReverse = showStack.reverse();
    // Bs4Kartoteka.topBs4Kartoteka = showStackReverse.at(-1);
    Bs4Kartoteka.topBs4Kartoteka = showStackReverse[showStackReverse.length -1]
    return showStackReverse;
  }

  static clearBs4ShowTooltip = () => {
    for (const bs4Kartoteka of Array.from(Bs4Kartoteka.bs4KartotekaMap.values())) {
      for (const bs4Option of Array.from(bs4Kartoteka.bs4Options.values())) {
        // 2025-05-12
        // if (bs4Option.bs4ShowTooltip) bs4Option.bs4ShowTooltip.clear();
        if (bs4Option.bs4ShowTooltip) bs4Option.bs4ShowTooltip.closeTooltipAndView();        
      }
    }    
  }

  message = null;
  onCloseBs4Action = null;
  bs4KartotekaId = null;
  bs4SourceKartotekaId = null;
  bs4Menu = null;  
  bs4MenuType = null;
  bs4MenuLogosrc = null;
  bs4Options = new Map();

  constructor(message) {
    if (!message?._Komunikat?.currentCardViewId) {
      console.log('=== Error === !!! Bs4Kartoteka no currentCardViewId', message);
      return null;
    }        
  
    this.message = message;
    this.onCloseBs4Action = message._Komunikat?.onCloseBs4Action;
    this.bs4KartotekaId = message._Komunikat.currentCardViewId;
    this.bs4SourceKartotekaId = message?._IdBs4Source;       
    this.bs4Menu = message?._Komunikat?.pageToolbar;
    this.bs4MenuType = message?._Komunikat?.bs4MenuType;
    this.bs4MenuLogosrc = message._Komunikat.logosrc;    
    Bs4Kartoteka.add(this)
    if (this.isFirst()) Bs4Kartoteka.firstBs4KartotekaId = this.bs4KartotekaId;
    this.eventEmit = new EventEmit();    
    this.dockingRegion = this.getDockingRegion();
    this.createModel()    
  }

  createModel() {
    this.bs4Options.clear();    
    if (this.message?._Komunikat?.pageToolbar) this.bs4Menu = this.message?._Komunikat?.pageToolbar;
    const optionId = this.message?._Komunikat?.optionId;        
    const type = String(this.getPageParam(optionId, 'optType'));
    // console.log('... bs4kartoteka createModel...', optionId, this.optionId, type, this)
    this.bs4Option = bs4OptionBinding({
      bs4Source: 'Bs4Kartoteka', 
      bs4KartotekaId: this.bs4KartotekaId, 
      optionId: optionId, 
      optionType: type,
    }) 

    this.setUxTemplate(this.message?._Komunikat?.uxCardTemplate)
    Bs4I18N.bs4ConstructorMode = this.isConstructorMode();    
    Bs4Kartoteka.clearBs4ShowTooltip();    
    this.bs4Option.bs4ShowTooltip = new Bs4ShowTooltip(this, this.bs4Option, Boolean(this.message?._Komunikat?.bs4RoboAssist));
    this.goLeftArrow = parseInt(this.message?._Komunikat?.goLeftArrow) === 1;
    this.goRightArrow = parseInt(this.message?._Komunikat?.goRightArrow) === 1;
  }

  isConstructorMode = () => Boolean(this.message?._Komunikat?.bs4ConstructorMode);

  getPageParam(optionId, param) {
    return this.message?._Komunikat?.pageParams[optionId]?.[param];
	}

  getBs4CardMainForObject = () => {
    return this.message?._Komunikat?.bs4CardMainForObject;
  }

  defaultUxTemplate = {    
    class: 216,
    name: 'Bs4Kartoteka',
    body: {
      Kartoteka: {
        spacing: 1,
        box: {},
      },
    },
  };
  
  setUxTemplate = (id) => {
    if (!id) id = this.message?._Komunikat?.uxCardTemplate;
    this.uxTemplate = getUxTemplate(this.defaultUxTemplate, 0, id, this.bs4KartotekaId);
  }

  getUxTemplateEditor = (uxEditor) => {

    return [{ 
      label: Bs4I18N.getTT('Kartoteka', 'Kartoteka', 'Bs4Kartoteka'),
      setUxTemplate: this.setUxTemplate,
      getUxTemplate: () => this.uxTemplate,
      types: [TYPE_BS4KARTOTEKA],
      onReset: () => this.uxTemplate.body.Kartoteka = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Kartoteka)),
      Content: (props) => {
        const {} = useStateUxTemplate(TYPE_BS4KARTOTEKA);
        const uxBody = this.uxTemplate.body.Kartoteka;
        const type = TYPE_BS4KARTOTEKA;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='color'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='backgroundColor'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='borderColor'/>
            </Stack>                                  
            
            <uxEditor.ViewCssNumber types={type} value={uxBody} name='spacing'/>
            <uxEditor.ViewCssShadow types={type} value={uxBody.box} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderWidth'/>

            {/* <Bs4UxMainTemplate.uxEditor.ViewCssText types={type} value={uxBody.box} name='height'/> */}
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='padding'/>            
          </Box>          
        );
      },
    }]
  }

  getDockingRegion() {
    if (this.isFirst()) return Bs4Kartoteka.DOCKING_REGION_CENTER;
    return Bs4Kartoteka.getDockingRegion(this.message)
  }

  on(name, onFunction) {
    this.eventEmit.on(name, onFunction);  
  }

  off(onFunction) {
    this.eventEmit.off(onFunction);  
  }  

  isTop = false;
  visibility = true;

  getVisibility() {
    return this.visibility;
  }

  setVisibility(visibility, smallScreen) {
    if (this.visibility === visibility) return;
    this.visibility = visibility;
    const rightBs4Kartoteka = this.getChildrenRight();
    if (rightBs4Kartoteka && !smallScreen) rightBs4Kartoteka.setVisibility(visibility, smallScreen);
    // console.log('...setVisibility...', this.visibility, this.getTitle())
    this.eventEmit.trigger(Bs4Kartoteka.CHANGE_VISIBILITY, visibility);   
  }

  getParent() {
    return Bs4Kartoteka.get(this.bs4SourceKartotekaId);
  }
  
  getChildren() {
    const bs4KartotekaArray = Array.from(Bs4Kartoteka.bs4KartotekaMap.values());
    return bs4KartotekaArray.filter(bs4Kartoteka => bs4Kartoteka.bs4SourceKartotekaId === this.bs4KartotekaId);
  }

  getChildrenRight = () => {
    return Array.from(Bs4Kartoteka.bs4KartotekaMap.values()).find(bs4KartotekaChild => 
      bs4KartotekaChild.bs4SourceKartotekaId === this.bs4KartotekaId && bs4KartotekaChild.dockingRegion === Bs4Kartoteka.DOCKING_REGION_RIGHT
    )
  }

  getDirty() {
    let dirty = [];
    for (const option of Array.from(this.bs4Options.values())) {
      dirty = dirty.concat(option?.bs4Form?.getDirty())
    }
    return dirty;
  }

  isDirty() {
    for (const option of Array.from(this.bs4Options.values())) {
      if (!option?.bs4Form?.criterion && option?.bs4Form?.isDirty()) return true;
      if (option?.bs4Grid?.isDirty()) return true;
    }
    return false;
  }

  first = false;

  isFirst() {
    return this.first;
  }

  getBs4Option(optionId) { 
    return this.bs4Options.get(String(optionId));
  }

  addBs4Option(optionId, option) {
    this.bs4Options.set(String(optionId), option);
  }
  
  getFormFieldValue(optionId, inputId, props) {
    const fieldValues = this.message?._Komunikat?.field_values[optionId] || {};
    let value = fieldValues[inputId];
    if (props.criterion && ! value) {
      value = props.field.value;
    }
    return value;
  }  
  
  getOpcjeZest(optionId) {
    return this?.message?._Komunikat?.opcje_zest[optionId];
  }

  getReportMenu(optionId) {
    const objectMenu = this.getOpcjeZest(optionId);
    if (!objectMenu) return [];
    return Object.values(objectMenu).map(item => {
      if (item?.items?.length === 1) {          
        return item.items[0];          
      }
      return item;
    })
  }

  cardMenu = null;
  setCardMenu = (menu) => {
    this.cardMenu = menu;
  }

  handleMenuClick = (item) => {
    this.canClose()
    .then(msg => {
      this.onMenuClickCanClose(item)    
    })
    .catch(msg => console.log('=== Error === setMessage', msg))
  }

  onMenuClickCanClose = (item) => {
    Bs4MainDispatch.commandParser('Bs4MenuClick', {optionId: item.bs4Id}, this.bs4KartotekaId);
  }

  openCenCloseDialog = () => {
    console.log('=== ERROR === openCenCloseDialog not implemented');
  }  

  canClose = (text) => {    
    return new Promise((resolve, reject) => {      
      if (this.isDirty()) { 
        this.canCloseResolve = () => resolve();
        this.canCloseReject = () => reject();
        this.openCenCloseDialog(true, text);
      } else {
        resolve()
      }
    });
  }

  afterCanClose = (ok) => {
    ok ? this.canCloseResolve() : this.canCloseReject();
    delete this.canCloseResolve;
    delete this.canCloseReject;
  }

  canCloseTab = (text) => {    
    return new Promise((resolve, reject) => {      
      this.canCloseTabResolve = () => resolve();
      this.canCloseTabReject = () => reject();
      this.setAskToCanCloseTab(true);
    });
  }

  afterCanCloseTab = (ok) => {
    ok ? this.canCloseTabResolve() : this.canCloseTabReject();
    delete this.canCloseTabResolve;
    delete this.canCloseTabReject;
  }

  setMessageUpdate = null;

  setMessage = (message, toBeContinue) => {
    Bs4MainDispatch.speedRun((tag) => {
      console.log(Bs4MainDispatch.speedStartTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.bs4Option?.optionId))
    }, '..Kartoteka..');

    this.canClose()
    .then(msg => {      
      this.bs4Options.clear()
      this.message = message;
      // this.toBeContinue = toBeContinue;
      if (this.setToBeContinue) this.setToBeContinue(toBeContinue);
      this.createModel();
      this.setMiniLeftMenu();
      this.setMessageUpdate(Date.now());
    })
    .catch(msg => {
      console.log('=== Error === setMessage', msg);
    })
  };  

  // 972 – Nr 49584 - Niezapisane zmiany a przycisk typu "Link do strony programu" [Core]
  canBs4FormFieldValue = (goBs4FormFieldValue) => {
    // console.log(new Error('canBs4FormFieldValue'));
    this.canClose()
    .then(msg => {
      console.log('=== Ok === bs4FormFieldValue')      
      goBs4FormFieldValue();
    })
    .catch(msg => {
      console.log('=== Error === bs4FormFieldValue', msg);
    })
  }

  ViewComponentCanClose = (props) => {
    const changesWereNotSavedTT = Bs4I18N.getTT('Zmiany nie zostały zapisane', 'Changes were not saved', 'Bs4ReportTabulator');
    const leavePageTT = Bs4I18N.getTT('Opuścić stronę ?', 'Leave page ?', 'Bs4ReportTabulator');
    const yesTT = Bs4I18N.getTT('Tak', 'Tak', 'Bs4Kartoteka');
    const noTT = Bs4I18N.getTT('Nie', 'Nie', 'Bs4Kartoteka');

    this.getDirty().forEach(field => {
    })

    const handleOk = () => {      
      this.changesSaved();
      this.openCenCloseDialog(false);
      this.afterCanClose(true);
    };

    const handleCancel = () => {      
      this.openCenCloseDialog(false);
      this.afterCanClose(false);
    };
  
    return (
      <Dialog open>
        <DialogTitle>{changesWereNotSavedTT}</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table size="small">        
              <TableBody>
                {this.getDirty().map((field) => (                  
                  <TableRow key={field.props.inputId}>
                    <TableCell><field.Bs4Label/></TableCell>                    
                    {/* <TableCell>{field.props.field.xtype}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <DialogContentText>            
            {props.text ? props.text : leavePageTT}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk}>{yesTT}</Button>
          <Button onClick={handleCancel} autoFocus>{noTT}</Button>
        </DialogActions>
      </Dialog>
    )
  }

  getFormElement(inputId) {
    for (const option of Array.from(this.bs4Options.values())) {
      const element = option?.bs4Form?.getFormElement(inputId)
      if (element) return element;
    }
  }

  removeElementDom(message) {
    const element = this.getFormElement(message?._Komunikat?.elementId)

    if (element) {
      element.removeElementDom();      
      return true;
    }

    for (const bs4Kartoteka of this.getChildren()){
      if (bs4Kartoteka.removeElementDom(message)) return true;
    }

    return false;
  }

  showElementDom(message) {
    const element = this.getFormElement(message?._Komunikat?.elementId)

    if (element) {
      element.showElementDom();
      return true;
    }

    for (const bs4Kartoteka of this.getChildren()){
      if (bs4Kartoteka.showElementDom(message)) return true;
    }
    
    return false;
  }

  changesSaved() {
    this.atrybProgressbar(null);
    for (const option of Array.from(this.bs4Options.values())) {
      option?.bs4Grid?.changesSaved();
      if (option?.bs4Form?.criterion) continue;
      option?.bs4Form.getFields().forEach(field => field.changesSaved())      
    }
  }

  elementNewValue(message) {
    // console.log(this.getFormElement(message?._Komunikat?.elementId), message);
    const formElement = this.getFormElement(message?._Komunikat?.elementId);
    if (!formElement) return;
    formElement.bs4Form.setStopAtrybOnchange(true)
    formElement.setValueBs4(message._Komunikat.value);
    formElement.bs4Form.setStopAtrybOnchange(false);
    
    //this.notValidElementDom(message)

    // Test elementGridreload - usunąć!
    // for (const option of Array.from(this.bs4Options.values())) {
    //   for (const field of option?.bs4Form.getFields()) {
    //     message._Komunikat.elementId = field.inputId;
    //     this.elementGridreload(message);    
    //   }
    // }    
  }

  elementAddValue = (message) => {
    this.getFormElement(message?._Komunikat?.elementId)?.elementAddValue(message._Komunikat.value);
  }

  elementSetStore = (message) => {
    this.getFormElement(message?._Komunikat?.elementId)?.elementSetStore(message._Komunikat.value);
  }

  notValidElementDom = (message) => {
    const notValidElementDom = this.getFormElement(message?._Komunikat?.elementId)?.notValidElementDom;
    if (notValidElementDom) notValidElementDom(message._Komunikat.value);
  }

  elementSetTimer = (message) => {
    const elementSetTimer = this.getFormElement(message?._Komunikat?.elementId)?.elementSetTimer;
    if (elementSetTimer) elementSetTimer(message._Komunikat);
  }

  filePickerData = (message) => {
    const filePickerData = this.getFormElement(message?._Komunikat?.elementId)?.filePickerData;
    if (filePickerData) filePickerData(message._Komunikat.value);
    else console.log('=== Error === filePickerData not implemented');
  }
  
  askToConfirm = (message, subscription) => {
    console.log('=== Error === askToConfirm not implemented');
  }

  atrybProgressbar = (message) => {
    console.log('=== Error === atrybProgressbar not implemented');
  }

  formFieldsRefresh = (message) => {    
    const option = this.getBs4Option(message?._Komunikat?.optionId);
    if (option?.bs4Form) {
      this.message = message;
      option.bs4Form.formFieldsRefresh(message);
    } else {
      console.log('=== Error === formFieldsRefresh option:', option);  
    }
  }

  setProgressDetails = (message) => {
    console.log('=== Error === setProgressDetails not implemented');
  }

  showTooltip = (message) => {
    this.bs4Option.bs4ShowTooltip.addTooltip(message);
  }

  setMiniLeftMenu = (miniLeftMenu) => {
    if (this.bs4Option?.getMainObject()?.setMiniLeftMenu) this.bs4Option?.getMainObject().setMiniLeftMenu(miniLeftMenu);
  }

  ViewComponentAskToConfirm = (props) => {    
    const yesTT = Bs4I18N.getTT('Tak', 'Tak', 'Bs4Kartoteka');
    const noTT = Bs4I18N.getTT('Nie', 'Nie', 'Bs4Kartoteka');

    const handleOk = () => {      
      this.askToConfirm(null);
      Bs4MainDispatch.commandParser(props.message._Komunikat.com, props.message._Komunikat.passBackParams, this.bs4KartotekaId);
      if (props.callback) props.callback?.ok()
    };

    const handleCancel = () => {      
      this.askToConfirm(null);
      if (props.callback) props.callback?.cancel();
    };
  
    return (
      <Dialog open>
        <DialogTitle>{props.message._Komunikat.askTitle}</DialogTitle>
        <DialogContent>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <HelpIcon color="warning" sx={{fontSize: 48}}/>
            <DialogContentText>{props.message._Komunikat.askMsg}</DialogContentText>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk}>{yesTT}</Button>
          <Button onClick={handleCancel} autoFocus>{noTT}</Button>
        </DialogActions>
      </Dialog>
    )
  }

  ViewComponentCanCloseTab = (props) => {    
    const AreYouSureTT = Bs4I18N.getTT('Are you sure you want to close the current tab?', 'Czy na pewno chcesz zamknąć bieżącą zakładkę?', 'Bs4Kartoteka');
    const yesTT = Bs4I18N.getTT('Tak', 'Tak', 'Bs4Kartoteka');
    const noTT = Bs4I18N.getTT('Nie', 'Nie', 'Bs4Kartoteka');     

    const handleOk = () => {      
      this.setAskToCanCloseTab(null);
      this.afterCanCloseTab(true);
      window.close();
    };

    const handleCancel = () => {      
      this.setAskToCanCloseTab(null);
      this.afterCanCloseTab(false);
    };
  
    return (
      <Dialog open>
        {/* <DialogTitle>{AreYouSureTT}</DialogTitle> */}
        <DialogContent>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <HelpIcon color="warning" sx={{fontSize: 48}}/>
            <DialogContentText>{AreYouSureTT}</DialogContentText>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk}>{yesTT}</Button>
          <Button onClick={handleCancel} autoFocus>{noTT}</Button>
        </DialogActions>
      </Dialog>
    )
  }

  ViewComponentAtrybProgressbar = (props) => {    
    const [progressDetails, setProgressDetails] = React.useState(null);
    const value = parseFloat(progressDetails?.current_progress_count) / parseFloat(progressDetails?.final_progress_count) * 100.0;
        
    const handleCancel = () => {     
      const details = {operation: 1};
      if (props.message.field) {
        details.currFormId = props.message.field.formId;
      } else if (props.message.menuItem) {
        details.reportOptionId = props.message.menuItem.bs4Id;
      } else {
        console.log('...Progressbar...no...id...', props.message);
        return
      }

      Bs4MainDispatch.commandParser('bs4CheckProgress', details, this.bs4KartotekaId);
      this.atrybProgressbar(null);
    };    

    React.useEffect(() => {      
      this.setProgressDetails = (message) => {
        setProgressDetails(message?._Komunikat);
      }

      let continueAsk = true;
      const startAtrybProgressbar = () => {
        if (!continueAsk) return;
        const details = {};
        if (props.message.field) {
          details.currFormId = props.message.field.formId;
        } else if (props.message.menuItem) {
          details.reportOptionId = props.message.menuItem.bs4Id;
        } else {
          return
        }

        Bs4MainDispatch.commandParser('bs4CheckProgress', details, this.bs4KartotekaId);
        setTimeout(startAtrybProgressbar, 3 * 1000);
      }

      startAtrybProgressbar();

      return () => {
        continueAsk = false
        //console.log('... ViewComponentAtrybProgressbar ... KONIEC ', progressDetails);
      }
    }, [])
  
    
    //console.log('... ViewComponentAtrybProgressbar ...', progressDetails, parseFloat(progressDetails?.current_progress_count), parseFloat(progressDetails?.final_progress_count), value);        
    
    return (
      <Dialog 
        open
        fullWidth
        maxWidth={'xs'}
      >
        <DialogTitle>{progressDetails?.name}</DialogTitle>
        <DialogContent>
          <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
            <DialogContentText>{progressDetails?.description}</DialogContentText>
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: '100%', mr: isNullOrNaN(value) ? 0 : 1 }}>
                <LinearProgress variant={isNullOrNaN(value) ? 'indeterminate' : 'determinate'} value={value} />
              </Box>
              {isNullOrNaN(value) ? null :
                <Box sx={{ minWidth: 35 }}>
                  <Typography variant="body2" color="text.secondary">{`${Math.round(value)}%`}</Typography>
                </Box>
              }
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} autoFocus>{Bs4I18N.getTT('Abort', 'Przerwij', 'Bs4Kartoteka')}</Button>
        </DialogActions>
      </Dialog>
    )
  }

  gridReload(message) {
    const element = this.getFormElement(message?._Komunikat?.elementId);
    for (const option of Array.from(this.bs4Options.values())) {      
      if (!element && option?.bs4Grid?.reload) {
        option.bs4Grid.reload();
      }
      for (const field of Array.from(option.bs4Form.getFields() || [])) {
        if ((!element || element === field.props.inputId) && field.gridReload) {
          field.gridReload();
        }
      }
    }
  }

  elementGridreload(message) {
    const element = this.getFormElement(message?._Komunikat?.elementId);
    for (const option of Array.from(this.bs4Options.values())) {
      if (option?.bs4Grid?.reload && option.bs4Grid.optionId == element.props.field?.idSourceReport) {
        option.bs4Grid.reload();
      }      
    }
  }

  menuStructureRefresh(message) {
    for (const option of Array.from(this.bs4Options.values())) {
      if (option?.bs4Grid?.menuStructureRefresh) {
        option.bs4Grid.menuStructureRefresh(message);
      }      
    }
  }
  
  onlyCloseWindow(toBeContinue) {
    this.canClose()
    .then(msg => {
      if (this.isFirst()) {
        this.canCloseTab()
        .then(msg => {
          window.close();
        })
        .catch(msg => {
          console.log('=== onlyCloseWindow === NO', msg);
        });
        return;
      }

      Bs4Kartoteka.remove(this.bs4KartotekaId)
      .then(() => {      
        Bs4MainWindow.showStack(toBeContinue);      
      })
      .catch((error) => {      
        console.log('=== onlyCloseWindow ===', error)
        Bs4MainWindow.showStack();
      });
      })
    .catch(msg => {
      console.log('=== Error === onlyCloseWindow canClose!!!', msg);
    })    
  }

  addDelayedTabsData = (message) => {
    console.log('=== ERROR === addDelayedTabsData not implemented', message);
  }

  getTitle = () => {
    let title1 = this.message?._Komunikat?.pageName;
    let title2 = '';
    const pageLineElems = this.message?._Komunikat?.pageLineElems;
    const optionId = this.message?._Komunikat?.optionId;
    if(pageLineElems && pageLineElems['1'] && pageLineElems['1'][optionId]) {
      title1 = pageLineElems['1'][optionId];
    } 
    if(pageLineElems && pageLineElems['2'] && pageLineElems['2'][optionId]) {
      title2 = pageLineElems['2'][optionId];
    }      

    return {title1, title2};
  }

  Bs4Title = () => {
    const {title1, title2} = this.getTitle()

    React.useEffect(() => {
      if (this.getVisibility() && this.dockingRegion === Bs4Kartoteka.DOCKING_REGION_CENTER) {
        document.title = title1;
      }
    })

    return (
      <Box display='flex' flexDirection='row' flexWrap='wrap' justifyContent='center' alignItems='center'>
        <Typography variant="h6">{title1}</Typography>
        &nbsp;&nbsp;
        <Typography variant="body2" sx={{color: '#888888'}}>{title2}</Typography>
      </Box>
    )
  } 

  handleBackClick = (e) => {
    //2023-03-27 e.stopPropagation(): prevent any event Click Away
    
    e.stopPropagation();
    Bs4Kartoteka.remove(this.bs4KartotekaId)
    .then((msg) => {
      if (this.onCloseBs4Action) {
        Bs4MainDispatch.commandParser('Bs4OnCloseWindow', { onCloseBs4Action: this.onCloseBs4Action }, this.bs4KartotekaId);
      }
      Bs4MainWindow.showStack();
    })
    .catch((msg) => {
      console.log('=== Error ===', msg);
      console.log('=== Error ===', this.bs4KartotekaId, [...Array.from(Bs4Kartoteka.bs4KartotekaMap)]);
    });
  }  

  Bs4KartotekaFunction = (props) => {
    const [visibility, setVisibility] = React.useState(null);
    const isAddNew = () => this.isConstructorMode() && Boolean(this.bs4Option.getMainObject() instanceof Bs4Form);
    const isArtistMode = () => !!this.message._Komunikat.bs4ArtistMode;
    const isConstructorMode = () => !!this.message._Komunikat.bs4ConstructorMode;    
    const isRefresh = () => !this.message._Komunikat.bs4hideRefresh;
    const isMoveToTab = () => !this.message._Komunikat.bs4hideMoveToTab && !Bs4MainDispatch.getMobile();
        
    const handleRefreshClick = () => {
      Bs4MainDispatch.commandParser('Bs4PageRefresh', {}, this.bs4KartotekaId);      
    }   

    const handleAddNewClick = () => {
      const mainObject = this.bs4Option.getMainObject();
      if (mainObject.setAddNew) mainObject.setAddNew(true);
    } 
    
    const handleGearClick = () => {
      Bs4MainDispatch.commandParser('Bs4OpenCard', {targetObject: this.bs4Option.optionId, targetOption: 300 }, this.bs4KartotekaId);      
    }

    const handlePaintbrushClick = () => {
      if (this.openUxTemplateEditor) this.openUxTemplateEditor();
    } 

    const handleExternalLinkClick = () => {
      delete window.localStorage.bs4ExternalLink;
      const bs4ExternalLink = {cardData: {...this.message}};
      if (Array.isArray(this.bs4Menu)) bs4ExternalLink.cardData._Komunikat.pageToolbar = [...this.bs4Menu];
      bs4ExternalLink.cardData._Typ= 'CARD_DATA'

      if (this.bs4SourceKartotekaId == Bs4MainWindow.BS4LAUNCHMAINPAGE) { //Main window
        bs4ExternalLink.mainPageDetails = Bs4MainWindow.mainPageDetails
        bs4ExternalLink.cardData._IdBs4Source = Bs4MainWindow.BS4LAUNCHMAINPAGE;
      }
    
      window.localStorage.bs4ExternalLink = JSON.stringify(bs4ExternalLink)
      let url = window.location.href.split("#")[0];	
      const appleBs4 = Bs4MainDispatch.getAppleBs4()
      if (appleBs4) window.open(url, '_self').focus();
      else window.open(url, '_blank').focus();    
    }

    React.useEffect(() => {
      this.eventEmit.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);   
      return () => this.eventEmit.off(setVisibility);
    }, [setVisibility])

    const title = this.getTitle();
    
    // console.log('...Bs4Kartoteka...Bs4KartotekaFunction', title.title1, visibility, this.bs4Option?.bs4ShowTooltip?.currentTooltip, this.bs4Option?.bs4ShowTooltip?.tooltipArray)

    return (
      <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} flexWrap='wrap'>
        {isAddNew() ?           <IconButton onClick={handleAddNewClick}><i className="fas fa-plus-circle"></i></IconButton> : null}
        {isArtistMode() ?       <IconButton onClick={handlePaintbrushClick}><i className="fa-solid fa-paintbrush"></i></IconButton> : null}
        {isConstructorMode() ?  <IconButton onClick={handleGearClick}><i className="fa-solid fa-gear"></i></IconButton> : null}
        {this.bs4Option?.bs4ShowTooltip?.ViewShowTooltip ? <this.bs4Option.bs4ShowTooltip.ViewShowTooltip/> : null}
        {isRefresh() ?          <IconButton onClick={handleRefreshClick}><i className="fa-solid fa-arrows-rotate"></i></IconButton> : null}
        {isMoveToTab() ?        <IconButton onClick={handleExternalLinkClick}><i className="fa-solid fa-arrow-up-right-from-square"></i></IconButton> : null}
      </Stack>
    )
  }

  Bs4Header = (props) => {
    const bs4Kartoteka = this;
    const bgcolor = (parseInt(this?.message?._Komunikat?.bs4CardType) === 13) ? '#aaaaff' : 'transparent';
    const sxCursor = bs4Kartoteka.dockingRegion === Bs4Kartoteka.DOCKING_REGION_WINDOW ? {cursor: 'move'} : {};

    return (
      <Stack 
        ref={props.refHeader} 
        direction="row" 
        justifyContent="space-between" 
        alignItems="center" 
        sx={{
          ...sxCursor, 
          bgcolor: bgcolor, 
        }}>
        <Stack direction="row" justifyContent='space-between' alignItems="center" spacing={1}>
          {!bs4Kartoteka.isFirst() &&
            <IconButton onClick={bs4Kartoteka.handleBackClick}><i className="fa-solid fa-arrow-left"/></IconButton>
          }
          <bs4Kartoteka.Bs4Title/>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
          <bs4Kartoteka.Bs4KartotekaFunction/>
          {props.MenuIconButton}
        </Stack>
      </Stack>
    )
  }

  ChildRightBs4Kartoteka = (props) => {    
    const key = 'bs4KartotekaChildRightWidth';
    const [width, setWidth] = React.useState(parseFloat(window.localStorage.getItem(key)));    
    const refResize = React.useRef(null);

    const handleResizeStop = (e, direction, ref, d) => {
      const newWidth = (width || refResize.current?.props?.size?.width) + d.width;      
      setWidth(newWidth)      
      window.localStorage.setItem(key, String(newWidth));
    }    

    if (!props.childRightBs4Kartoteka) return null;

    const getWidth = () => {
      if (width) return width;    
      if (props.refBs4Kartoteka.current?.offsetWidth && refResize.current?.state?.width) {
        return (props.refBs4Kartoteka.current?.offsetWidth + refResize.current?.props?.size?.width) / 2;
      }
      if (props.refBs4Kartoteka.current?.offsetWidth) {
        return (props.refBs4Kartoteka.current?.offsetWidth) / 2;
      }
      return '45%';
    }    

    return (
      <Resizable 
        ref={refResize}
        size={{width: getWidth()}}
        maxWidth='98%'
        onResizeStop={handleResizeStop}
        enable={{ top:false, right: false, bottom: false, left: true, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }}        
        //boundsByDirection={true}
      >
        <Box height={'100%'} display='flex' flexDirection='column' overflow='hidden'>
          <props.childRightBs4Kartoteka.ViewBs4Kartoteka/>
        </Box>
      </Resizable>
    )
  }

  ViewUxTemplate = (props) => {
    const bs4Kartoteka = this;
    const [open, setOpen] = React.useState(false);

    const uxEditor = React.useMemo(() => {
      return new UxTemplateEditor();
    }, [])

    const mainObject = this.bs4Option.getMainObject();

    const uxTemplateEditors = React.useMemo(() => {            
      // const options = Array.from(this.bs4Options.values()).map(option => option.getMainObject().getUxTemplateEditor(uxEditor));      
      // const editors = [];
      // for (const option of options) {
      //   editors.push(...option);
      // }

      return [
        ...Bs4MainWindow.instance?.bs4MainWindowUx?.getUxTemplateEditor(uxEditor),
        ...this.getUxTemplateEditor(uxEditor),
        ...mainObject.getUxTemplateEditor(uxEditor),
        //...editors,
      ]
    }, [mainObject])
    
    React.useEffect(() => {
      this.openUxTemplateEditor = () => setOpen(true);      
    }, [])

    return (
      <uxEditor.ViewUxTemplate
        bs4KartotekaId={bs4Kartoteka.bs4KartotekaId}
        optionId={mainObject.optionId}
        open={open}
        onClose={() => setOpen(false)}
        context={null}
        tabs={uxTemplateEditors}
      />
    )
  } 

  handleRefresh = () => {    
    Bs4MainDispatch.commandParser('Bs4PageRefresh', {}, this.bs4KartotekaId);    
    return new Promise((resolve) => setTimeout(resolve, 50));        
  }
  
  xxxx0 = {};

  ViewBs4Kartoteka = React.memo((props) => {
    const bs4Kartoteka = this;
    const smallScreen = React.useContext(SmallScreenContext);
    Bs4Kartoteka.smallScreen = smallScreen;
    const [messageUpddate, setMessageUpdate] = React.useState(Date.now());
    const [canCloseDialog, setCanCloseDialog] = React.useState(false);
    const [canCloseDialogText, setCanCloseDialogText] = React.useState(null);
    const [askToConfirm, setAskToConfirm] = React.useState(null);
    const [askToCanCloseTab, setAskToCanCloseTab] = React.useState(null);
    const [askToConfirmCallback, setAskToConfirmCallback] = React.useState(null);
    const [atrybProgressbar, setAtrybProgressbar] = React.useState(null);
    const theme = useTheme();
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4KARTOTEKA);
    const [MenuIconButton, setMenuIconButton] = React.useState(<span/>);
    const [targetScroll, setTargetScroll] = React.useState(null);
    const [fabTop, setFabTop] = React.useState(() => {
      const bs4kartotekaFabPosition = parseInt(window.localStorage.getItem(Bs4Kartoteka.BS4KARTOTEKA_FAB_POSITION));
      if (isNullOrNaN(bs4kartotekaFabPosition)) return 1;
      return bs4kartotekaFabPosition;
    }
    );
    const refBs4Kartoteka = React.useRef(null);    

    const [toBeContinue, setToBeContinue] = React.useState(null);
    React.useEffect(() => {
      this.setToBeContinue = setToBeContinue;
      Bs4MainDispatch.toBeContinueParsingBs4ResponseMessgs(toBeContinue, this);
    }, [toBeContinue, setToBeContinue])

    const boxSxIn = React.useMemo(() => {
      if (smallScreen && this.uxTemplate?.body?.Kartoteka) {
        this.uxTemplate.body.Kartoteka.spacing = 1;
        this.uxTemplate.body.Kartoteka.box.margin = 0;
        this.uxTemplate.body.Kartoteka.box.padding = 0;
      }
      return getBoxSx(this.uxTemplate?.body?.Kartoteka?.box, theme);
    }, [theme, dateTimeStamp, smallScreen])

    this.setMessageUpdate = setMessageUpdate;           
    
    const getCanCloseDialog = ()  => {
      const bs4Kartoteka = this;
      if (canCloseDialog) return (
        <bs4Kartoteka.ViewComponentCanClose open={true} text={canCloseDialogText}/>
      )
    }

    const getAtrybProgressbar = ()  => {
      const bs4Kartoteka = this;
      if (atrybProgressbar) return (
        <bs4Kartoteka.ViewComponentAtrybProgressbar message={atrybProgressbar}/>
      )
    }

    const getAskToConfirm = ()  => {
      const bs4Kartoteka = this;
      if (askToConfirm) return (
        <bs4Kartoteka.ViewComponentAskToConfirm message={askToConfirm} callback={askToConfirmCallback}/>
      )
    }

    const getCanCloseTabDialog = ()  => {
      const bs4Kartoteka = this;
      if (askToCanCloseTab) return (
        <bs4Kartoteka.ViewComponentCanCloseTab/>
      )
      return null;
    }

    React.useEffect(() => {
      this.openCenCloseDialog = (open, text) => {
        setCanCloseDialog(open);
        setCanCloseDialogText(text || null);
      }
      this.askToConfirm = (message, callback) => {
        setAskToConfirm(message || null);
        setAskToConfirmCallback(callback || null);
      }
      this.atrybProgressbar = (message) => setAtrybProgressbar(message);
      this.setAskToCanCloseTab = setAskToCanCloseTab;
      this.setTargetScroll = setTargetScroll;
      setTargetScroll(this.targetScroll);
    }, [setCanCloseDialog, setCanCloseDialogText, setAskToConfirm, setAtrybProgressbar, setTargetScroll])    

    React.useEffect(() => {
      if (this.cardMenu?.setOptionId) this.cardMenu?.setOptionId(this.bs4Option.optionId);
      return () => {
        if (this.cardMenu?.setOptionId) this.cardMenu?.setOptionId(null);
      }
    }, [this.cardMenu, this.bs4Option.optionId])
      
    const logosrc = !Bs4MainDispatch.getMobile() && this.bs4MenuLogosrc && Bs4MainDispatch.getUrlPath(this.bs4MenuLogosrc);
    
    const uxKartoteka = bs4Kartoteka.uxTemplate.body.Kartoteka;   

    let timePointerDownFab = null;

    const handlePointerDownFab = (event) => {
      timePointerDownFab = setTimeout(() => {
        const bs4kartotekaFabPosition = (fabTop + 1) % 3;
        window.localStorage.setItem(Bs4Kartoteka.BS4KARTOTEKA_FAB_POSITION, bs4kartotekaFabPosition);
        setFabTop(bs4kartotekaFabPosition);
        timePointerDownFab = null;
      }, 2000);
    }

    const handleClickFabLeft = (event) => {
      if (!timePointerDownFab) return;
      clearTimeout(timePointerDownFab);
      Bs4MainDispatch.commandParser('bs4CardArrow', {direction: 'left'}, this.bs4KartotekaId);
    }

    const handleClickFabRight = (event) => {
      if (!timePointerDownFab) return;
      clearTimeout(timePointerDownFab);
      Bs4MainDispatch.commandParser('bs4CardArrow', {direction: 'right'}, this.bs4KartotekaId);
    }

    React.useEffect(() => {
      Bs4MainDispatch.toBeContinueParsingBs4ResponseMessgs(this.toBeContinue, this);
    }, [this.toBeContinue])

    const fabTopPercent =  (10 + fabTop * 40)+'%';
    
    // const xxxx0 = {
    //   messageUpddate: messageUpddate,
    //   canCloseDialog: canCloseDialog,
    //   canCloseDialogText: canCloseDialogText,
    //   askToConfirm: askToConfirm,
    //   askToCanCloseTab: askToCanCloseTab,
    //   askToConfirmCallback: askToConfirmCallback,
    //   atrybProgressbar: atrybProgressbar,
    //   theme: theme,
    //   dateTimeStamp: dateTimeStamp,
    //   MenuIconButton: MenuIconButton,
    //   targetScroll: targetScroll,
    //   fabTop: fabTop,    
    //   toBeContinue: toBeContinue,
    //   boxSxIn: boxSxIn,
    // };

    // const okkk = shallowEqual(this.xxxx0, xxxx0, '...Speed...EQ.');
    // this.xxxx0 = xxxx0;

    Bs4MainDispatch.speedRun((tag) => {
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.bs4Option?.optionId))
  }, '..Kartoteka..View.');
    

    return (            
      <Box flex={1} display='flex' flexDirection='row' overflow='hidden' sx={boxSxIn}>
        <Box flex={1} flexDirection="column" display='flex' overflow='hidden' position={'relative'}>
          <HideOnScroll type={bs4Kartoteka.bs4Option?.optionId}>
            <Box 
              flexDirection="column" 
              display='flex' 
              overflow='hidden' 
              px={uxKartoteka.spacing}
              gap={uxKartoteka.spacing / 3}
              pb={uxKartoteka.spacing / 3}
              sx={{touchAction: 'none'}}
            >
              {logosrc ?
              <Stack direction="row" justifyContent='flex-start' alignItems="center" sx={{p: 1}}>
                <img style={{'maxHeight':'300px'}} src={logosrc} border="0"/>
              </Stack> : null}
              <bs4Kartoteka.Bs4Header refHeader={props.refHeader} MenuIconButton={MenuIconButton}/>
              <Bs4HorizontalMenu 
                anchor='right'
                bs4KartotekaId={bs4Kartoteka.bs4KartotekaId}
                targetOption={300}
                bs4Menu={bs4Kartoteka.bs4Menu} 
                onMenuClick={bs4Kartoteka.handleMenuClick} 
                addDelayedTabsData              
                setMenu={bs4Kartoteka.setCardMenu}
                bs4MenuType={bs4Kartoteka.bs4MenuType}
                setMenuIconButton={setMenuIconButton}                
                variantMenuIcon='ellipsis-stroke'
                variantMenuName='Więcej'                
              />
            </Box>
          </HideOnScroll>
          <Box flex={1} flexDirection="row" display='flex' overflow='hidden'>
            <Bs4VerticalMenu
              anchor='left'
              bs4KartotekaId={bs4Kartoteka.bs4KartotekaId} 
              targetOption={300}
              bs4Menu={bs4Kartoteka.bs4Menu} 
              onMenuClick={bs4Kartoteka.handleMenuClick} 
              addDelayedTabsData
              setMenu={bs4Kartoteka.setCardMenu}
              bs4MenuType={bs4Kartoteka.bs4MenuType}
              setMenuIconButton={setMenuIconButton}     
              variantMenuIcon='ellipsis-stroke'
              variantMenuName='Więcej'                  
            />
            <bs4Kartoteka.bs4Option.ViewComponent 
              ref={refBs4Kartoteka} 
              uxKartoteka={uxKartoteka} 
            />
          </Box>
          <Fab 
            size='small' 
            color='primary' 
            onClick={handleClickFabLeft}
            onPointerDown={handlePointerDownFab}
            sx={{
              ...(bs4Kartoteka.goLeftArrow ? null : {display: 'none'}),
              position: 'absolute', 
              top: fabTopPercent, 
              left: 10, 
              opacity: 0.3, 
              // zIndex: 2000,
            }}
          >
          <i className='fa-solid fa-chevron-left'></i>
          </Fab>
          <Fab 
            size='small' 
            color='primary' 
            onClick={handleClickFabRight}
            onPointerDown={handlePointerDownFab}
            sx={{
              ...(bs4Kartoteka.goRightArrow ? null : {display: 'none'}),
              position: 'absolute', 
              top: fabTopPercent, 
              right: 10, 
              opacity: 0.3, 
              // zIndex: 2000,
            }}
          >
          <i className='fa-solid fa-chevron-right'></i>
          </Fab>
        </Box>                
        <bs4Kartoteka.ChildRightBs4Kartoteka childRightBs4Kartoteka={props.childRightBs4Kartoteka} refBs4Kartoteka={refBs4Kartoteka}/>
        {getCanCloseDialog()}
        {getAskToConfirm()}
        {getAtrybProgressbar()}
        {getCanCloseTabDialog()}
        <bs4Kartoteka.ViewUxTemplate/>
        <bs4Kartoteka.bs4Option.bs4ShowTooltip.ViewComponent/>
      </Box>         
    );              
  });

  getWindowSize = () => {
    switch (this.message?._Komunikat?.bs4CardType) {
      case '12': return {width: '80%', height: '80%'};
      case '15': return {width: '60%', height: '85%'};
      case '16': return {width: '25%', height: '25%'};
      default  : return {width: '80%', height: '80%'};
    }
  }

  toBeContinue = null;
  
  ViewComponent = (props) => {
    const bs4Kartoteka = this;
    const refHeader = React.useRef(null);

    const childRightBs4Kartoteka = props.smallScreen ? null : this.getChildrenRight();

    // const [toBeContinue, setToBeContinue] = React.useState(null);
    // React.useEffect(() => {
    //   this.setToBeContinue = setToBeContinue;
    //   Bs4MainDispatch.toBeContinueParsingBs4ResponseMessgs(toBeContinue, this);
    // }, [toBeContinue, setToBeContinue])

    // 2025-03-25
    // React.useEffect(() => {
    //   console.log('...???...bs4Kartoteka.toBeContinue...', this.getTitle(), this.toBeContinue, this)
    //   Bs4MainDispatch.toBeContinueParsingBs4ResponseMessgs(this.toBeContinue, this);
    // }, [this.toBeContinue])

    // console.log('...bs4Kartoteka.ViewComponent...', this.getTitle(), this.visibility, this)

    if (bs4Kartoteka.dockingRegion === Bs4Kartoteka.DOCKING_REGION_WINDOW && !props.smallScreen) return (
      <Bs4Modal 
        open 
        onClose={bs4Kartoteka.handleBackClick} 
        isTop={bs4Kartoteka.isTop} //ClickAwayListener nie powinien działać w przypadku kartotek zasłoniętych przez inne okna „modalne”.
        {...bs4Kartoteka.getWindowSize()} 
        bs4Kartoteka={bs4Kartoteka} 
        sygn='kartoteka'
        refHeader={refHeader}        
      >
        <bs4Kartoteka.ViewBs4Kartoteka childRightBs4Kartoteka={childRightBs4Kartoteka} refHeader={refHeader}/>
      </Bs4Modal>
    ); else return (
      <Bs4Box
        id={'Bs4Kartoteka_'+bs4Kartoteka.bs4KartotekaId}
        position='absolute'
        top={0} 
        left={0} 
        right={0}
        bottom={0}
        display='flex' 
        flexDirection='column'
        overflow='hidden'
        bs4Kartoteka={bs4Kartoteka}
      >
        <bs4Kartoteka.ViewBs4Kartoteka childRightBs4Kartoteka={childRightBs4Kartoteka}/>
      </Bs4Box>
    );
  }
}